import baseUrl from "../../config/baseURL";

const getUrlCreator = (baseUrl) => {
  const baseUrlSplitIndex = baseUrl.indexOf("api/v1");
  const mainUrl = baseUrl.substring(0, baseUrlSplitIndex);
  const apiVersion = baseUrl.substring(baseUrlSplitIndex, baseUrl.length);
  return (categoryString) => `${mainUrl}${categoryString}/${apiVersion}`;
};

export const WAREHOUSE = "warehouse";

export const getCategoryBaseUrl = (endpointCategory) => {
  const getFullUrl = getUrlCreator(baseUrl);
  return getFullUrl(endpointCategory);
};
